import { render, staticRenderFns } from "./ListBranches.vue?vue&type=template&id=af0a1926&"
import script from "./ListBranches.vue?vue&type=script&lang=js&"
export * from "./ListBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports